import { Component } from '@angular/core';
import { BackButtonDirective } from '@app/core/routing/navigation/back-button.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-forbidden',
  templateUrl: './forbidden.component.html',
  imports: [
    BackButtonDirective,
    TranslatePipe,
  ],
})
export class ForbiddenComponent {
}
